import axios from 'axios';

import deleteCustomAttribute from '../../../api/intergration/pim/products/dropshipment/deletes/deleteCustomAttribute';
import patchCustomAttribute from '../../../api/intergration/pim/products/dropshipment/patches/patchCustomAttribute';
import postAddProductLog from '../../../api/intergration/pim/products/dropshipment/posts/postAddProductLog';

function exclusivityTo(userEmail, nike_wizard) {
  return new Promise((resolve, reject) => {
    const toDate = nike_wizard.productData.other_attributes.to;

    if (toDate === '') {
      deleteCustomAttribute(
        nike_wizard.productId,
        'JD',
        'exclusivity_date_to',
      )
        .then((res) => {
          if (res.data.Success) {
            // if (nike_wizard.editedValues.includes('to')) {
            postAddProductLog(
              nike_wizard.productId,
              'JD',
              `[INFO]: User ${userEmail} deleted ExclusivityDateTo for ProductId: ${nike_wizard.productId} - SiteCode: JD`,
            );
            // }
            resolve(res.data);
          } else {
            postAddProductLog(
              nike_wizard.productId,
              'JD',
              `[ERROR]: User ${userEmail} FAILED to delte ExclusivityDateTo for ProductId: ${nike_wizard.productId} - SiteCode: JD. Return Error Message: ${res.data.ErrorMessage}`,
            );
            reject(res.data.ErrorMessage);
          }
        })
        .catch((err) => {
          // If the error message contains the word Cancel then dont do error stuff.
          // Reason for this is because if a request is cancelled, this isn't an error to do with
          // saving data so the user doesn't need to be notified of this.
          if (axios.isCancel(err)) {
            resolve();
          } else {
            postAddProductLog(
              nike_wizard.productId,
              'JD',
              `[ERROR]: User ${userEmail} FAILED to delte ExclusivityDateTo for ProductId: ${nike_wizard.productId} - SiteCode: JD. Return Error Message: ${err.message}`,
            );
            reject(err);
          }
        });
    } else {
      patchCustomAttribute(
        nike_wizard.productId,
        'JD',
        'exclusivity_date_to',
        new Date(toDate),
        'GB',
      )
        .then((res) => {
          if (res.data.Success) {
            // if (nike_wizard.editedValues.includes('to')) {
            postAddProductLog(
              nike_wizard.productId,
              'JD',
              `[INFO]: User ${userEmail} updated ExclusivityDateTo: ${toDate} for ProductId: ${nike_wizard.productId} - SiteCode: JD - ISO: GB`,
            );
            // }
            resolve(res.data);
          } else {
            postAddProductLog(
              nike_wizard.productId,
              'JD',
              `[ERROR]: User ${userEmail} FAILED to update ExclusivityDateTo: ${toDate} for ProductId: ${nike_wizard.productId} - SiteCode: JD - ISO: GB. Return Error Message: ${res.data.ErrorMessage}`,
            );
            reject(res.data.ErrorMessage);
          }
        })
        .catch((err) => {
          // If the error message contains the word Cancel then dont do error stuff.
          // Reason for this is because if a request is cancelled, this isn't an error to do with
          // saving data so the user doesn't need to be notified of this.
          if (axios.isCancel(err)) {
            resolve();
          } else {
            postAddProductLog(
              nike_wizard.productId,
              'JD',
              `[ERROR]: User ${userEmail} FAILED to update ExclusivityDateTo: ${toDate} for ProductId: ${nike_wizard.productId} - SiteCode: JD - ISO: GB. Return Error Message: ${err.message}`,
            );
            reject(err);
          }
        });
    }
  });
}

export default exclusivityTo;
